import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadFolderOffers = (documentId, siteId) =>
  get(`${url}/leasingDocument/${documentId}/${siteId}/offers-contract-generation`);
const generateContract = (documentId, siteId, detailIds, generateSeparateContracts) =>
  post(`${url}/LeasingFolders/${documentId}/${siteId}/${generateSeparateContracts}/generate-contract-for-assets`, {
    documentId,
    siteId,
    documentDetails: detailIds,
    generateSeparateContracts
  });

const exp = {
  loadFolderOffers,
  generateContract
};
export default exp;
